// CookiePolicy.tsx
import React from "react";
import "./css/CookiePolicy.css";

export const CookiePolicy: React.FC = () => {
    return (
        <div className="cookie">
            <div className="cookie__container">
                <h1 className="cookie__title">Skitterbook Cookie Policy</h1>
                <p className="cookie__last-updated">
                    Last updated: {new Date().toLocaleDateString("en-GB")}
                </p>

                <section className="cookie__section">
                    <h2>1. Introduction</h2>
                    <p>
                        This Cookie Policy explains how Skitterbook (“we”, “us”, “our”)
                        uses cookies and similar technologies within the Skitterbook web
                        application (“the Service”). By using the Service, you agree to the
                        use of cookies as described in this policy.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>2. What are cookies?</h2>
                    <p>
                        Cookies are small text files stored on your device when you visit a
                        website or use a web application. They help websites function
                        correctly, remember your preferences and improve performance.
                    </p>
                    <p>
                        Cookies used by Skitterbook do not give us access to your device or
                        any information beyond what is necessary for the operation of the
                        Service.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>3. How Skitterbook uses cookies</h2>
                    <p>We use cookies for the following purposes:</p>

                    <h3>3.1 Essential cookies</h3>
                    <p>
                        These cookies are required for the Service to function. Without
                        them, certain features will not work properly.
                    </p>
                    <ul>
                        <li>Maintaining your session while you are signed in.</li>
                        <li>Storing account‑related state during use of the Service.</li>
                        <li>Ensuring secure and reliable operation.</li>
                    </ul>

                    <h3>3.2 Preference cookies</h3>
                    <p>
                        These cookies store your application settings and preferences to
                        provide a smoother and more personalised experience.
                    </p>
                    <ul>
                        <li>Remembering UI settings and configuration choices.</li>
                        <li>Preserving layout or feature preferences.</li>
                    </ul>

                    <h3>3.3 Performance cookies</h3>
                    <p>
                        We use anonymous analytics to understand how the Service is used and
                        to improve reliability and performance.
                    </p>
                    <p>
                        Analytics data is collected through Microsoft Azure Application
                        Insights and may include:
                    </p>
                    <ul>
                        <li>Device and browser information.</li>
                        <li>Feature usage patterns.</li>
                        <li>Performance and diagnostic data.</li>
                    </ul>
                    <p>
                        This data is anonymous and does not identify individual users.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>4. Third‑party cookies</h2>
                    <p>
                        Skitterbook does not use third‑party cookies for advertising,
                        marketing or tracking. No external integrations or payment
                        processors are used in this version of the application.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>5. Managing cookies</h2>
                    <p>
                        You can control or delete cookies through your browser settings.
                        Most browsers allow you to:
                    </p>
                    <ul>
                        <li>Block or restrict cookies.</li>
                        <li>Delete existing cookies.</li>
                        <li>Receive notifications when cookies are being used.</li>
                    </ul>
                    <p>
                        If you disable essential cookies, some features of Skitterbook may
                        not function correctly or may become unavailable.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>6. Changes to this Cookie Policy</h2>
                    <p>
                        We may update this Cookie Policy from time to time to reflect
                        changes in technology, legal requirements or how we use cookies.
                        When updates are made, the “Last updated” date at the top of this
                        page will be revised.
                    </p>
                </section>

                <section className="cookie__section">
                    <h2>7. Contact us</h2>
                    <p>
                        If you have any questions about this Cookie Policy, please contact
                        us at:
                    </p>
                    <p>
                        <strong>Email:</strong>{" "}
                        <a href="mailto:farauthoring@gmail.com">
                            farauthoring@gmail.com
                        </a>
                        <br />
                        <strong>Address:</strong> FAR Authoring Ltd., 41 Grange Park,
                        Ealing, London, W5 3PR, United Kingdom
                    </p>
                </section>

                <section className="cookie__section cookie__disclaimer">
                    <p>
                        This Cookie Policy is provided for information purposes and may
                        benefit from independent legal review to ensure full compliance with
                        applicable regulations.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default CookiePolicy;
